import styled from 'styled-components'

export const Messages = styled.div``

export const Message = styled.p`
  ${({ theme }) => theme.textStyles.text}
  color: ${({ theme }) => theme.colors.red};
`
